import React from 'react';
import ReactDOM from 'react-dom';

export {AssemblyNewService};


class AssemblyNewService extends React.Component{
    constructor(props) {
        super(props);
        this.state = { product: props.product, opened: false };
        this.toggleBox = this.toggleBox.bind(this);
    }

    toggleBox(){
        this.setState({opened: !this.state.opened});
    }

    render() {
        return (
            <>
            {this.props.group.groups.length == 0 ? (
            <div className={"mcfb-item-services-group-section"}>
                <div className={"mcfb-item-services-collapse"}>
                    <a className={"link-w-border accessories__item-link_arrow" + (this.state.opened ? ' collapsed' : '')}  onClick={this.toggleBox} aria-expanded={this.state.opened}>{tools.getLangField(this.props.group,'name')}</a>
                </div>
                <div className={"mcfb-item-services-body collapse " + (this.state.opened ? ' show' : '')}>
                    {this.props.group.additional_services.map((service) => (
                        <div className="accessories__item-info-row" key={"service_" + this.props.product.product_id + '_' + service.product_id}>
                            <div className="form-check pb-0">
                                <input className="form-check-input"
                                       name={"service_" +this.props.product.id + '_' + this.props.group.id}
                                       type={this.props.group.additional_services.length == 1 ? "checkbox" : "radio"}
                                       id={"service_" + this.props.product.id + '_' + service.product_id}

                                       checked={this.props.services[this.props.group.id] == service.product_id}
                                       onChange={() => this.props.handleServiceToggle(service.product_id, this.props.group.id, this.props.product.id)}
                                />
                                <label className="form-check-label"
                                       onClick={(e) => {
                                           if(e.target.previousSibling.checked && e.target.previousSibling.type== 'radio'){
                                               e.preventDefault();
                                               e.stopPropagation();
                                               e.target.previousSibling.checked = false;
                                               this.props.handleServiceToggle(service.product_id, this.props.group.id, this.props.product.id);
                                           }
                                       }}
                                       htmlFor={"service_" + this.props.product.id + '_' + service.product_id}>{tools.getLangField(service,'name')}&nbsp;</label>
                            </div>
                            <div className="accessories__item-bonus">+{service.price} ₴</div>
                        </div>
                    ))}
                </div>
            </div>
        ) : (
            <>
                {this.props.group.groups.map((group) => (
                    <React.Fragment key={group.id}>
                        <AssemblyNewService
                            group={group}
                            product={this.props.product}
                            services={this.props.services}
                            handleServiceToggle={this.props.handleServiceToggle}
                        />
                    </React.Fragment>
                ))}
            </>

        )}
        </>
        );
    }
}